import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: theme.palette.background.gray_50,
  },
  field: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    borderRadius: 4,
    width: "178px",
  },
  fieldTitle: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.tertiary,
  },
  fieldValue: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  deductionStyle: {
    color: theme.palette.text.error_primary,
  },
}));

export default useStyles;
